// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Manage Company - Enterprise Corporate Design
   Matching Dashboard Theme
   ============================================ */

/* CSS Variables - Matching Dashboard Theme */
:root {
  --manage-company-bg: #f8f9fa;
  --manage-company-text: #000000;
  --manage-company-text-muted: #4a5568;
  --manage-company-border: rgba(135, 206, 235, 0.3);
  --light-sky-blue: #87ceeb;
  --light-red: #ff6b6b;
  --white: #ffffff;
  --navy-blue: #001f3f;
  --transition: all 0.2s ease;
}

/* ============================================
   Main Container
   ============================================ */
.ManageCompany_manageCompany__LmsJk {
  min-height: calc(100vh - 60px);
  background: var(--manage-company-bg);
  padding: 1.5rem;
  color: var(--manage-company-text);
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* ============================================
   Header
   ============================================ */
.ManageCompany_header__GVdzW {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.ManageCompany_headerLeft__rX66n {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.ManageCompany_headerIcon__asOsa {
  color: var(--light-sky-blue);
}

.ManageCompany_title__tmME7 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--manage-company-text);
  margin: 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.ManageCompany_addButton__u81Nl {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: #000000;
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.ManageCompany_addButton__u81Nl:hover {
  background: #001f3f;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.ManageCompany_addButton__u81Nl:active {
  transform: translateY(0);
}

/* ============================================
   Notification
   ============================================ */
.ManageCompany_notification__Y5RDM {
  padding: 0.875rem 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
  animation: ManageCompany_slideDown__IyUH1 0.3s ease;
}

.ManageCompany_notificationSuccess__phRgX {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
  border: 1px solid rgba(67, 160, 71, 0.3);
}

.ManageCompany_notificationError__MnqJ6 {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
  border: 1px solid rgba(255, 107, 107, 0.3);
}

@keyframes ManageCompany_slideDown__IyUH1 {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================
   Loading & Error States
   ============================================ */
.ManageCompany_loadingContainer__pAXQL {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.ManageCompany_spinner__rs3l- {
  color: var(--light-sky-blue);
  animation: ManageCompany_spin__gyccg 1s linear infinite;
}

@keyframes ManageCompany_spin__gyccg {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.ManageCompany_errorAlert__I6zJ5 {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: var(--light-red);
  color: white;
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
}

.ManageCompany_errorAlert__I6zJ5 svg {
  flex-shrink: 0;
}

/* ============================================
   Table Container
   ============================================ */
.ManageCompany_tableContainer__pjVcZ {
  background: var(--white);
  border: 1px solid var(--manage-company-border);
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ManageCompany_table__I4Muf {
  width: 100%;
  border-collapse: collapse;
}

.ManageCompany_table__I4Muf thead {
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.ManageCompany_table__I4Muf th {
  padding: 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  background-color: #000000;
  color: #ffffff;
}

.ManageCompany_table__I4Muf tbody tr {
  border-bottom: 1px solid var(--manage-company-border);
  transition: var(--transition);
}

.ManageCompany_table__I4Muf tbody tr:hover {
  background: rgba(135, 206, 235, 0.05);
}

.ManageCompany_table__I4Muf tbody tr:last-child {
  border-bottom: none;
}

.ManageCompany_table__I4Muf td {
  padding: 1rem;
  font-size: 0.875rem;
  color: var(--manage-company-text);
}

.ManageCompany_emptyState__G4gJD {
  text-align: center;
  padding: 3rem 1rem;
  color: var(--manage-company-text-muted);
  font-style: italic;
}

/* ============================================
   Status Badge
   ============================================ */
.ManageCompany_statusBadge__yOH3- {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ManageCompany_statusActive__R592n {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
}

.ManageCompany_statusInactive__BVhnq {
  background: rgba(255, 107, 107, 0.1);
  color: var(--light-red);
}

/* ============================================
   Action Buttons
   ============================================ */
.ManageCompany_actionButtons__mIJAp {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.ManageCompany_iconButton__I\\+A3x {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: 1px solid var(--manage-company-border);
  border-radius: 0.375rem;
  color: var(--manage-company-text);
  cursor: pointer;
  transition: var(--transition);
}

.ManageCompany_iconButton__I\\+A3x:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
  color: var(--light-sky-blue);
}

.ManageCompany_iconButton__I\\+A3x:active {
  transform: scale(0.95);
}

.ManageCompany_deleteButton__ns7I0:hover {
  background: rgba(255, 107, 107, 0.1);
  border-color: var(--light-red);
  color: var(--light-red);
}

/* ============================================
   Modal
   ============================================ */
.ManageCompany_modalOverlay__BUAyP {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
}

.ManageCompany_modal__KeTN6 {
  background: var(--white);
  border-radius: 0.5rem;
  width: 100%;
  max-width: 800px;
  max-height: calc(100vh - 2rem);
  max-height: calc(100dvh - 2rem);
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.ManageCompany_modalHeader__Nw52L {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);
  color: var(--white);
  border-radius: 0.5rem 0.5rem 0 0;
  flex-shrink: 0;
}

.ManageCompany_modalTitle__9vGjd {
  font-size: 1.125rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 0;
}

.ManageCompany_closeButton__O7Ymn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  color: var(--white);
  cursor: pointer;
  border-radius: 0.25rem;
  transition: var(--transition);
}

.ManageCompany_closeButton__O7Ymn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.ManageCompany_modalBody__CN1kL {
  padding: 1.5rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
}

.ManageCompany_modalFooter__klaCI {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1.25rem 1.5rem;
  border-top: 1px solid var(--manage-company-border);
  background: #f8f9fa;
  border-radius: 0 0 0.5rem 0.5rem;
  flex-shrink: 0;
}

/* ============================================
   Form Elements
   ============================================ */
.ManageCompany_formGroup__FvWTL {
  margin-bottom: 1.25rem;
}

.ManageCompany_label__bNDsj {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--manage-company-text);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ManageCompany_required__j1DU4 {
  color: var(--light-red);
}

.ManageCompany_input__wgn1b {
  width: 100%;
  padding: 0.625rem 0.875rem;
  font-size: 0.875rem;
  border: 1px solid var(--manage-company-border);
  border-radius: 0.375rem;
  background: var(--white);
  color: var(--manage-company-text);
  transition: var(--transition);
  box-sizing: border-box;
}

.ManageCompany_input__wgn1b:focus {
  outline: none;
  border-color: var(--light-sky-blue);
  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);
}

.ManageCompany_input__wgn1b::placeholder {
  color: var(--manage-company-text-muted);
}

.ManageCompany_switchLabel__5bcDY {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
}

.ManageCompany_switch__\\+hjo0 {
  width: 40px;
  height: 20px;
  appearance: none;
  background: #cbd5e0;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  transition: var(--transition);
}

.ManageCompany_switch__\\+hjo0:checked {
  background: var(--light-sky-blue);
}

.ManageCompany_switch__\\+hjo0::before {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--white);
  top: 2px;
  left: 2px;
  transition: var(--transition);
}

.ManageCompany_switch__\\+hjo0:checked::before {
  left: 22px;
}

.ManageCompany_switchText__WFNNq {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--manage-company-text);
}

.ManageCompany_helpText__7p04O {
  font-size: 0.8125rem;
  color: var(--manage-company-text-muted);
  margin-bottom: 0.75rem;
  margin-top: 0.25rem;
}

.ManageCompany_submitButton__dpm\\+U {
  padding: 0.625rem 1.5rem;
  background: var(--light-sky-blue);
  color: var(--white);
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.ManageCompany_submitButton__dpm\\+U:hover {
  background: #6bb6d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);
}

.ManageCompany_submitButton__dpm\\+U:active {
  transform: translateY(0);
}

.ManageCompany_cancelButton__VJ5N0 {
  padding: 0.625rem 1.5rem;
  background: transparent;
  color: var(--manage-company-text);
  border: 1px solid var(--manage-company-border);
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.ManageCompany_cancelButton__VJ5N0:hover {
  background: rgba(135, 206, 235, 0.1);
  border-color: var(--light-sky-blue);
}

/* ============================================
   Responsive Design - Tablet
   ============================================ */
@media (max-width: 1024px) {
  .ManageCompany_manageCompany__LmsJk {
    padding: 1.25rem;
  }

  .ManageCompany_title__tmME7 {
    font-size: 1.25rem;
  }

  .ManageCompany_table__I4Muf th,
  .ManageCompany_table__I4Muf td {
    padding: 0.875rem;
    font-size: 0.8125rem;
  }
}

/* ============================================
   Responsive Design - Mobile
   ============================================ */
@media (max-width: 768px) {
  .ManageCompany_manageCompany__LmsJk {
    padding: 1rem;
  }

  .ManageCompany_header__GVdzW {
    flex-direction: column;
    align-items: flex-start;
  }

  .ManageCompany_title__tmME7 {
    font-size: 1.125rem;
  }

  .ManageCompany_addButton__u81Nl {
    width: 100%;
    justify-content: center;
  }

  .ManageCompany_tableContainer__pjVcZ {
    overflow-x: auto;
  }

  .ManageCompany_table__I4Muf {
    min-width: 600px;
  }

  .ManageCompany_table__I4Muf th,
  .ManageCompany_table__I4Muf td {
    padding: 0.75rem 0.5rem;
    font-size: 0.75rem;
  }

  .ManageCompany_modal__KeTN6 {
    max-width: 100%;
    max-height: calc(100vh - 2rem);
    max-height: calc(100dvh - 2rem);
  }

  .ManageCompany_modalHeader__Nw52L {
    padding: 1rem;
  }

  .ManageCompany_modalTitle__9vGjd {
    font-size: 1rem;
  }

  .ManageCompany_modalBody__CN1kL {
    padding: 1rem;
  }

  .ManageCompany_modalFooter__klaCI {
    padding: 1rem;
    flex-direction: column;
  }

  .ManageCompany_submitButton__dpm\\+U,
  .ManageCompany_cancelButton__VJ5N0 {
    width: 100%;
  }
}

/* ============================================
   Responsive Design - Small Mobile
   ============================================ */
@media (max-width: 480px) {
  .ManageCompany_manageCompany__LmsJk {
    padding: 0.75rem;
  }

  .ManageCompany_title__tmME7 {
    font-size: 1rem;
  }

  .ManageCompany_table__I4Muf th,
  .ManageCompany_table__I4Muf td {
    padding: 0.625rem 0.375rem;
    font-size: 0.6875rem;
  }

  .ManageCompany_iconButton__I\\+A3x {
    width: 28px;
    height: 28px;
  }

  .ManageCompany_iconButton__I\\+A3x svg {
    width: 16px;
    height: 16px;
  }
}

/* ============================================
   Accessibility
   ============================================ */
@media (prefers-reduced-motion: reduce) {
  * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}

/* Focus states for keyboard navigation */
.ManageCompany_iconButton__I\\+A3x:focus-visible,
.ManageCompany_addButton__u81Nl:focus-visible,
.ManageCompany_submitButton__dpm\\+U:focus-visible,
.ManageCompany_cancelButton__VJ5N0:focus-visible,
.ManageCompany_closeButton__O7Ymn:focus-visible,
.ManageCompany_input__wgn1b:focus-visible {
  outline: 2px solid var(--light-sky-blue);
  outline-offset: 2px;
}

`, "",{"version":3,"sources":["webpack://./src/styles/ManageCompany.module.css"],"names":[],"mappings":"AAAA;;;iDAGiD;;AAEjD,6CAA6C;AAC7C;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,oCAAoC;EACpC,iDAAiD;EACjD,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;iDAEiD;AACjD;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,SAAS;EACT,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,mDAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,uDAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,qBAAqB;EACrB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iDAAiD;EACjD,0EAA0E;EAC1E,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;;iDAEiD;AACjD;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,8CAA8C;EAC9C,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,0EAA0E;EAC1E,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kDAAkD;EAClD,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,8CAA8C;EAC9C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;;iDAEiD;AACjD;EACE;IACE,sCAAsC;IACtC,qCAAqC;EACvC;AACF;;AAEA,yCAAyC;AACzC;;;;;;EAME,wCAAwC;EACxC,mBAAmB;AACrB","sourcesContent":["/* ============================================\n   Manage Company - Enterprise Corporate Design\n   Matching Dashboard Theme\n   ============================================ */\n\n/* CSS Variables - Matching Dashboard Theme */\n:root {\n  --manage-company-bg: #f8f9fa;\n  --manage-company-text: #000000;\n  --manage-company-text-muted: #4a5568;\n  --manage-company-border: rgba(135, 206, 235, 0.3);\n  --light-sky-blue: #87ceeb;\n  --light-red: #ff6b6b;\n  --white: #ffffff;\n  --navy-blue: #001f3f;\n  --transition: all 0.2s ease;\n}\n\n/* ============================================\n   Main Container\n   ============================================ */\n.manageCompany {\n  min-height: calc(100vh - 60px);\n  background: var(--manage-company-bg);\n  padding: 1.5rem;\n  color: var(--manage-company-text);\n  width: 100%;\n  max-width: 100%;\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n\n/* ============================================\n   Header\n   ============================================ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.headerIcon {\n  color: var(--light-sky-blue);\n}\n\n.title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--manage-company-text);\n  margin: 0;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.addButton {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: #000000;\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.addButton:hover {\n  background: #001f3f;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.addButton:active {\n  transform: translateY(0);\n}\n\n/* ============================================\n   Notification\n   ============================================ */\n.notification {\n  padding: 0.875rem 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  animation: slideDown 0.3s ease;\n}\n\n.notificationSuccess {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n  border: 1px solid rgba(67, 160, 71, 0.3);\n}\n\n.notificationError {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n  border: 1px solid rgba(255, 107, 107, 0.3);\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================\n   Loading & Error States\n   ============================================ */\n.loadingContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.spinner {\n  color: var(--light-sky-blue);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.errorAlert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: var(--light-red);\n  color: white;\n  border-radius: 0.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n}\n\n.errorAlert svg {\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Table Container\n   ============================================ */\n.tableContainer {\n  background: var(--white);\n  border: 1px solid var(--manage-company-border);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table thead {\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table th {\n  padding: 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  background-color: #000000;\n  color: #ffffff;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid var(--manage-company-border);\n  transition: var(--transition);\n}\n\n.table tbody tr:hover {\n  background: rgba(135, 206, 235, 0.05);\n}\n\n.table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.table td {\n  padding: 1rem;\n  font-size: 0.875rem;\n  color: var(--manage-company-text);\n}\n\n.emptyState {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: var(--manage-company-text-muted);\n  font-style: italic;\n}\n\n/* ============================================\n   Status Badge\n   ============================================ */\n.statusBadge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.statusActive {\n  background: rgba(67, 160, 71, 0.1);\n  color: #43a047;\n}\n\n.statusInactive {\n  background: rgba(255, 107, 107, 0.1);\n  color: var(--light-red);\n}\n\n/* ============================================\n   Action Buttons\n   ============================================ */\n.actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.iconButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: 1px solid var(--manage-company-border);\n  border-radius: 0.375rem;\n  color: var(--manage-company-text);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.iconButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n  color: var(--light-sky-blue);\n}\n\n.iconButton:active {\n  transform: scale(0.95);\n}\n\n.deleteButton:hover {\n  background: rgba(255, 107, 107, 0.1);\n  border-color: var(--light-red);\n  color: var(--light-red);\n}\n\n/* ============================================\n   Modal\n   ============================================ */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n}\n\n.modal {\n  background: var(--white);\n  border-radius: 0.5rem;\n  width: 100%;\n  max-width: 800px;\n  max-height: calc(100vh - 2rem);\n  max-height: calc(100dvh - 2rem);\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.modalHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #000000 0%, #001f3f 50%, #000000 100%);\n  color: var(--white);\n  border-radius: 0.5rem 0.5rem 0 0;\n  flex-shrink: 0;\n}\n\n.modalTitle {\n  font-size: 1.125rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 0;\n}\n\n.closeButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: var(--white);\n  cursor: pointer;\n  border-radius: 0.25rem;\n  transition: var(--transition);\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.modalBody {\n  padding: 1.5rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n}\n\n.modalFooter {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  padding: 1.25rem 1.5rem;\n  border-top: 1px solid var(--manage-company-border);\n  background: #f8f9fa;\n  border-radius: 0 0 0.5rem 0.5rem;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   Form Elements\n   ============================================ */\n.formGroup {\n  margin-bottom: 1.25rem;\n}\n\n.label {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--manage-company-text);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.required {\n  color: var(--light-red);\n}\n\n.input {\n  width: 100%;\n  padding: 0.625rem 0.875rem;\n  font-size: 0.875rem;\n  border: 1px solid var(--manage-company-border);\n  border-radius: 0.375rem;\n  background: var(--white);\n  color: var(--manage-company-text);\n  transition: var(--transition);\n  box-sizing: border-box;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--light-sky-blue);\n  box-shadow: 0 0 0 3px rgba(135, 206, 235, 0.1);\n}\n\n.input::placeholder {\n  color: var(--manage-company-text-muted);\n}\n\n.switchLabel {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.switch {\n  width: 40px;\n  height: 20px;\n  appearance: none;\n  background: #cbd5e0;\n  border-radius: 10px;\n  position: relative;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.switch:checked {\n  background: var(--light-sky-blue);\n}\n\n.switch::before {\n  content: '';\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--white);\n  top: 2px;\n  left: 2px;\n  transition: var(--transition);\n}\n\n.switch:checked::before {\n  left: 22px;\n}\n\n.switchText {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--manage-company-text);\n}\n\n.helpText {\n  font-size: 0.8125rem;\n  color: var(--manage-company-text-muted);\n  margin-bottom: 0.75rem;\n  margin-top: 0.25rem;\n}\n\n.submitButton {\n  padding: 0.625rem 1.5rem;\n  background: var(--light-sky-blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.submitButton:hover {\n  background: #6bb6d4;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(135, 206, 235, 0.3);\n}\n\n.submitButton:active {\n  transform: translateY(0);\n}\n\n.cancelButton {\n  padding: 0.625rem 1.5rem;\n  background: transparent;\n  color: var(--manage-company-text);\n  border: 1px solid var(--manage-company-border);\n  border-radius: 0.375rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.cancelButton:hover {\n  background: rgba(135, 206, 235, 0.1);\n  border-color: var(--light-sky-blue);\n}\n\n/* ============================================\n   Responsive Design - Tablet\n   ============================================ */\n@media (max-width: 1024px) {\n  .manageCompany {\n    padding: 1.25rem;\n  }\n\n  .title {\n    font-size: 1.25rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.875rem;\n    font-size: 0.8125rem;\n  }\n}\n\n/* ============================================\n   Responsive Design - Mobile\n   ============================================ */\n@media (max-width: 768px) {\n  .manageCompany {\n    padding: 1rem;\n  }\n\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .title {\n    font-size: 1.125rem;\n  }\n\n  .addButton {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .tableContainer {\n    overflow-x: auto;\n  }\n\n  .table {\n    min-width: 600px;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.75rem 0.5rem;\n    font-size: 0.75rem;\n  }\n\n  .modal {\n    max-width: 100%;\n    max-height: calc(100vh - 2rem);\n    max-height: calc(100dvh - 2rem);\n  }\n\n  .modalHeader {\n    padding: 1rem;\n  }\n\n  .modalTitle {\n    font-size: 1rem;\n  }\n\n  .modalBody {\n    padding: 1rem;\n  }\n\n  .modalFooter {\n    padding: 1rem;\n    flex-direction: column;\n  }\n\n  .submitButton,\n  .cancelButton {\n    width: 100%;\n  }\n}\n\n/* ============================================\n   Responsive Design - Small Mobile\n   ============================================ */\n@media (max-width: 480px) {\n  .manageCompany {\n    padding: 0.75rem;\n  }\n\n  .title {\n    font-size: 1rem;\n  }\n\n  .table th,\n  .table td {\n    padding: 0.625rem 0.375rem;\n    font-size: 0.6875rem;\n  }\n\n  .iconButton {\n    width: 28px;\n    height: 28px;\n  }\n\n  .iconButton svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* ============================================\n   Accessibility\n   ============================================ */\n@media (prefers-reduced-motion: reduce) {\n  * {\n    transition-duration: 0.01ms !important;\n    animation-duration: 0.01ms !important;\n  }\n}\n\n/* Focus states for keyboard navigation */\n.iconButton:focus-visible,\n.addButton:focus-visible,\n.submitButton:focus-visible,\n.cancelButton:focus-visible,\n.closeButton:focus-visible,\n.input:focus-visible {\n  outline: 2px solid var(--light-sky-blue);\n  outline-offset: 2px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"manageCompany": `ManageCompany_manageCompany__LmsJk`,
	"header": `ManageCompany_header__GVdzW`,
	"headerLeft": `ManageCompany_headerLeft__rX66n`,
	"headerIcon": `ManageCompany_headerIcon__asOsa`,
	"title": `ManageCompany_title__tmME7`,
	"addButton": `ManageCompany_addButton__u81Nl`,
	"notification": `ManageCompany_notification__Y5RDM`,
	"slideDown": `ManageCompany_slideDown__IyUH1`,
	"notificationSuccess": `ManageCompany_notificationSuccess__phRgX`,
	"notificationError": `ManageCompany_notificationError__MnqJ6`,
	"loadingContainer": `ManageCompany_loadingContainer__pAXQL`,
	"spinner": `ManageCompany_spinner__rs3l-`,
	"spin": `ManageCompany_spin__gyccg`,
	"errorAlert": `ManageCompany_errorAlert__I6zJ5`,
	"tableContainer": `ManageCompany_tableContainer__pjVcZ`,
	"table": `ManageCompany_table__I4Muf`,
	"emptyState": `ManageCompany_emptyState__G4gJD`,
	"statusBadge": `ManageCompany_statusBadge__yOH3-`,
	"statusActive": `ManageCompany_statusActive__R592n`,
	"statusInactive": `ManageCompany_statusInactive__BVhnq`,
	"actionButtons": `ManageCompany_actionButtons__mIJAp`,
	"iconButton": `ManageCompany_iconButton__I+A3x`,
	"deleteButton": `ManageCompany_deleteButton__ns7I0`,
	"modalOverlay": `ManageCompany_modalOverlay__BUAyP`,
	"modal": `ManageCompany_modal__KeTN6`,
	"modalHeader": `ManageCompany_modalHeader__Nw52L`,
	"modalTitle": `ManageCompany_modalTitle__9vGjd`,
	"closeButton": `ManageCompany_closeButton__O7Ymn`,
	"modalBody": `ManageCompany_modalBody__CN1kL`,
	"modalFooter": `ManageCompany_modalFooter__klaCI`,
	"formGroup": `ManageCompany_formGroup__FvWTL`,
	"label": `ManageCompany_label__bNDsj`,
	"required": `ManageCompany_required__j1DU4`,
	"input": `ManageCompany_input__wgn1b`,
	"switchLabel": `ManageCompany_switchLabel__5bcDY`,
	"switch": `ManageCompany_switch__+hjo0`,
	"switchText": `ManageCompany_switchText__WFNNq`,
	"helpText": `ManageCompany_helpText__7p04O`,
	"submitButton": `ManageCompany_submitButton__dpm+U`,
	"cancelButton": `ManageCompany_cancelButton__VJ5N0`
};
export default ___CSS_LOADER_EXPORT___;
